import { useQueryGetCategories } from "@/apis/categories/getCategories";
import { useQueryGetAnswerRatio } from "@/apis/exam_progress/getRatio";
import type { ICategory } from "@/apis/categories/types";
import type { ISATQuestion } from "@/apis/exam_papers/getExamReport";
import { useParams } from "react-router-dom";

interface QuestionTableProps {
  title: string;
  questions: ISATQuestion[];
  showAccuracy?: boolean;
  startNumber?: number;
}

export const QuestionTable = ({
  title,
  questions,
  showAccuracy = false,
  startNumber = 1,
}: QuestionTableProps) => {
  const { data: categories } = useQueryGetCategories();
  const { id } = useParams();
  const { data: answerRatios } = useQueryGetAnswerRatio(id || "");

  const getCategoryShortName = (categoryId: string) => {
    const category = categories?.find(
      (cat: ICategory) => cat.id === categoryId
    );
    return category?.short_name || "-";
  };

  const getAnswerRatio = (questionId: string) => {
    const ratio = answerRatios?.find((r) => r.id === questionId);
    return `${Math.round((ratio?.correct_ratio || 0) * 100)}%`;
  };

  return (
    <>
      <div className="bg-gray-200 text-center font-bold py-1 border border-gray-300 text-[10px]">
        {title}
      </div>
      <table className="w-full border border-gray-200 text-[9px]">
        <thead>
          <tr className="bg-gray-200">
            <th className="border px-1 py-[1px]">No</th>
            <th className="border px-1 py-[1px]">Category</th>
            <th className="border py-[1px]">Correct Answer</th>
            <th className="border py-[1px]">Student Answer</th>
            <th className="border px-1 py-[1px]">O/X</th>
            {showAccuracy && <th className="border px-1 py-[1px]">%</th>}
          </tr>
        </thead>
        <tbody>
          {questions?.map((question, i) => (
            <tr key={question.question_id} className="text-center">
              <td className="border px-1 py-[1px]">{startNumber + i}</td>
              <td className="border px-1 py-[1px]">
                {getCategoryShortName(question.category_id)}
              </td>
              <td className="border px-1 py-[1px]">
                {question.correct_answer || "-"}
              </td>
              <td className="border px-1 py-[1px]">
                {question.user_answer || "-"}
              </td>
              <td className="border px-1 py-[1px]">
                {question.is_correct ? "O" : "X"}
              </td>
              {showAccuracy && (
                <td className="border px-1 py-[1px]">
                  {getAnswerRatio(question.question_id)}
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};
